import * as types from "./types";
import NovaAPI from "../../Axios/NovaAPI";
import { getItem, setItem } from "../../Auth/localStorageService";
import {
  ACCESS_DENIED,
  BAD_REQUEST,
  SUCCESS_STATUS,
} from "../../Auth/statusCodes";
import {
  NETWORK_ERROR,
  NETWORK_ERROR_MESSAGE,
  loginErrorMessages,
} from "../../consts/errorMessages";

export const setUserSessionTimeOut = (payload) => {
  return {
    type: types.SESSION_TIME_OUT,
    payload,
  };
};

export const isSuccessfullyLoggedIn = (boolean) => {
  return {
    type: types.IS_USER_SUCCESSFULLY_LOGGED_IN,
    payload: boolean,
  };
};

export const setIsLoginApiFailed = (value) => {
  return {
    type: types.IS_LOGIN_API_FAILED,
    payload: value,
  };
};

export const setLoginErrorMessage = (value) => {
  return {
    type: types.LOGIN_ERROR_MESSAGE,
    payload: value,
  };
};

export const setInvalidCredentialsError = (value) => {
  return {
    type: types.INVALID_CREDENTIALS,
    payload: value,
  };
};

export const setLoginRedirectRoute = (value) => {
  return {
    type: types.LOGIN_REDIRECT_ROUTE,
    payload: value,
  };
};

export const redirectUserFromDefaultPage = (payload) => {
  return {
    type: types.REDIRECT_USER_FROM_DEFAULT_PAGE,
    payload,
  };
};

export const setNewUserIsRegistered = (payload) => {
  return {
    type: types.NEW_USER_IS_REGISTERED,
    payload,
  };
};

export const setAccountRestored = (payload) => {
  return {
    type: types.ACCOUNT_IS_RESTORED,
    payload,
  };
};

export const resetRedirectUserFromDefaultPage = (payload) => {
  return {
    type: types.RESET_REDIRECT_USER_FROM_DEFAULT_PAGE,
    payload,
  };
};

export const isSigningInUser = (payload) => {
  return {
    type: types.IS_SIGNING_IN_USER,
    payload,
  };
};

export const setLoggingOutUser = (payload) => {
  return {
    type: types.LOGGING_OUT_USER,
    payload,
  };
};

export const loginUser = (userDetails, handleSendOtp) => {
  return (dispatch) => {
    dispatch(setIsLoginApiFailed(false));
    dispatch(setInvalidCredentialsError(false));
    dispatch(setLoginErrorMessage(""));
    dispatch(setUserSessionTimeOut(false));
    dispatch(isSigningInUser(true));
    NovaAPI.post("/user/auth/login", userDetails, {
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        if (res.status === SUCCESS_STATUS) {
          dispatch({
            type: types.LOGIN_USER,
            payload: res?.data?.data,
          });

          if (res?.data?.data?.isEmailVerified === false) {
            const prevEmail = getItem("USER_EMAIL");
            if (prevEmail !== userDetails.email) {
              setItem("USER_EMAIL", userDetails.email);
              handleSendOtp(false);
              return;
            }
            handleSendOtp(true);
            return;
          }
          dispatch(isSuccessfullyLoggedIn(true));
          dispatch(setNewUserIsRegistered(false));
          dispatch(setAccountRestored(false));
          setItem("AUTH", "AUTHENTICATED");
          return;
        }
      })
      .catch((err) => {
        dispatch(isSigningInUser(false));
        if ((navigator && !navigator.onLine) || err.message === NETWORK_ERROR) {
          dispatch(setLoginErrorMessage(NETWORK_ERROR_MESSAGE));
          return;
        }
        if (
          err.response?.data?.code === "INVALID_CREDENTIALS" ||
          err.response?.data?.code === "USER_NOT_FOUND" ||
          err.response?.data?.message === loginErrorMessages.NOT_AUTHORIZED
        ) {
          dispatch(setInvalidCredentialsError(true));
          return;
        }
        if (+err.response?.data?.errorCode === ACCESS_DENIED) {
          dispatch(setLoginErrorMessage(err.response?.data?.message));
          return;
        }
        if (+err.response?.data?.statusCode === BAD_REQUEST) {
          dispatch(setLoginErrorMessage(err.response?.data?.message));
          return;
        }
        dispatch(setIsLoginApiFailed(true));
        dispatch(isSuccessfullyLoggedIn(false));
      })
      .finally(() => {
        dispatch(isSigningInUser(false));
      });
  };
};
